import axios from "axios";
import { API_BASE_URL } from "utils/secrets";
import { refreshToken } from "./refreshToken";
import { EventBus } from "./eventBus";
import { API_ENDPOINTS } from "./constants";

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let loginPromiseResolve;
let requestQueue = [];

const loginPromise = () => {
  return new Promise((resolve) => {
    loginPromiseResolve = resolve;
  });
};

export const resolveLoginPromise = () => {
  if (loginPromiseResolve) {
    loginPromiseResolve();
    loginPromiseResolve = null;
  }
};

const retryQueuedRequests = async () => {
  while (requestQueue.length > 0) {
    const request = requestQueue.shift();
    try {
      await request();
    } catch (error) {
      console.error("Error retrying request:", error);
    }
  }
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 498 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const access_token = await refreshToken();
        originalRequest.headers["Authorization"] = `Bearer ${access_token}`;
        return api(originalRequest);
      } catch (refreshError) {
        if (refreshError.response && refreshError.response.status === 497) {
          EventBus.dispatch("showLoginPopup");

          requestQueue.push(async () => {
            const response = await api(originalRequest)
            if (originalRequest.method === 'get') {
              const baseUrl = originalRequest.url.split('?')[0];
              const params = originalRequest.params;
              
              if(baseUrl === API_ENDPOINTS.CONNECTIONS){
                if (params) {
                  const type = params.get('type');
                  if (type) {
                    EventBus.dispatch(`dataReceived-${baseUrl}-${type}`, response.data || []);
                  }
                }
              }
              else {
                EventBus.dispatch(`dataReceived-${baseUrl}`, response.data || []);
              }
            }
          });

          await loginPromise();

          await retryQueuedRequests();

          return new Promise((resolve, reject) => {});
        }

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);
